export const PROFILE_PERMISSION_CODES = {
    ACCESS_TO_TIMESHEET: 'AccessToTimeSheet',
    CAN_APPROVE: 'CanApprove',
    CAN_BILL: 'CanBill',
    CAN_DISAPPROVE: 'CanDisapprove',
    CAN_PAY_SUBSCRIPTION: 'CanPaySubscription',
    CAN_UNBILL: 'CanUnbill',
    CHANGE_EMPLOYEE_ROLES: 'ChangeEmployeeRoles',
    CHANGE_PERMISSIONS: 'ChangePermissions',
    EDIT_ABSENCE_TYPES: 'EditAbsenceTypes',
    EDIT_CLIENTS: 'EditClients',
    SHOW_AND_EDIT_COST_FOR_ALL_EMPLOYEES: 'ShowAndEditCostForAllEmployees',
    EDIT_EARLY_ACCESS: 'EditEarlyAccess',
    EDIT_EMPLOYEES: 'EditEmployees',
    EDIT_INTEGRATIONS: 'EditIntegrations',
    EDIT_JOB_EXECUTION_TIME: 'EditJobExecutionTime',
    EDIT_OLD_SHIFTS: 'EditOldShifts',
    EDIT_PROJECTS: 'EditProjects',
    EDIT_PROJECT_TYPES: 'EditProjectTypes',
    EDIT_VACATION_WITHOUT_APPROVAL: 'EditVacationWithoutApproval',
    EDIT_ROLES: 'EditRoles',
    EDIT_SHIFTS: 'EditShifts',
    EDIT_SHIFT_TYPES: 'EditShiftTypes',
    EDIT_TAG_TYPES: 'EditTagTypes',
    EDIT_TIMEZONE: 'EditTimezone',
    EDIT_WORK_DAYS: 'EditWorkDays',
    IMPORT_TIME_TRACKING: 'ImportTimeTracking',
    NOTIFICATION_AT_END_OF_MONTH: 'NotificationAtEndOfMonth',
    SHOW_ABSENCE_TYPES: 'ShowAbsenceTypes',
    APPROVE_DECLINE_ANY_VACATIONS: 'ApproveDeclineAnyVacations',
    SHOW_ALL_VACATIONS: 'ShowAllVacations',
    SHOW_CLIENTS: 'ShowClients',
    SHOW_COSTS_FOR_ALL_EMPLOYEES: 'ShowCostsForAllEmployees',
    SHOW_AND_EDIT_TIME_BANK_FOR_ALL_EMPLOYEES: 'ShowAndEditTimeBankForAllEmployees',
    SHOW_TIME_BANK_FOR_ALL_EMPLOYEES: 'ShowTimeBankForAllEmployees',
    SHOW_EARLY_ACCESS: 'ShowEarlyAccess',
    SHOW_EMPLOYEES: 'ShowEmployees',
    SHOW_INTEGRATIONS: 'ShowIntegrations',
    SHOW_PERMISSIONS: 'ShowPermissions',
    SHOW_PROJECTS: 'ShowProjects',
    SHOW_PROJECT_TYPES: 'ShowProjectTypes',
    SHOW_ROLES: 'ShowRoles',
    SHOW_SHIFT_TYPES: 'ShowShiftTypes',
    SHOW_SUMMARY_FOR_ALL_EMPLOYEES: 'ShowSummaryForAllEmployees',
    SHOW_TAG_TYPES: 'ShowTagTypes',
    SHOW_WORK_CALENDARS: 'ShowWorkCalendars',
} as const;

export type ProfilePermissionCode = typeof PROFILE_PERMISSION_CODES[keyof typeof PROFILE_PERMISSION_CODES];
